import React, { FC, MutableRefObject } from 'react';
import { makeStyles } from 'tss-react/mui';

import AttachFileIcon from '@mui/icons-material/AttachFile';

import { transactionsTypes } from 'companion-app-components/flux/transactions';

import QIconButton from 'components/QIconButton';

import { RegListItem, styles } from '../styles';

import type { AttributesType, CallbacksType } from '../types';

const useStyles = makeStyles()(styles as Record<string, any>);

interface AttachmentFieldProps {
  attributes: AttributesType;
  callbacks: CallbacksType;
  SHOW_ALL: boolean;
  fieldActive: boolean;
  txn: transactionsTypes.CashFlowTransaction;
  focusField: MutableRefObject<HTMLAnchorElement | null>;
}

const AttachmentField: FC<AttachmentFieldProps> = ({
  attributes,
  callbacks,
  SHOW_ALL,
  fieldActive,
  txn,
  focusField,
}) => {
  const { classes } = useStyles();
  return (
    <RegListItem
      {...attributes}
      tabIndex={null}
      className={classes.iconColumn}
      onClick={txn.attachments ? null : () => callbacks.handleMenu?.('addAttachments', txn)}
    >
      {txn.attachments && (txn.attachments.length > 0) && SHOW_ALL &&
        <QIconButton
          aria-label="View Attachments"
          autoFocus={fieldActive}
          ref={fieldActive ?
            (input) => {
              focusField.current = input; // eslint-disable-line
            } : null}
          focusRipple
          IconComponent={AttachFileIcon}
          onClick={() => callbacks.handleMenu?.('viewAttachments', txn)}
          tooltip={`Transaction has ${txn.attachments.length} attachment${txn.attachments.length > 1 ? 's' : ''}`}
          size="small-target"
        />}
    </RegListItem>
  );
};

export default AttachmentField;
